import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import JenisPengikatanCodeService from "services/Setup/Master/jenisPengikatanCodeService";
import { message, notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  jenisPengikatanCodeList: {},
};

export const getJenisPengikatanCodeList = createAsyncThunk(
  "jenisPengikatanCode/getJenisPengikatanCodeList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await JenisPengikatanCodeService.getJenisPengikatanCodeList(userInput);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      // notification.error({
      //   message: "Error",
      //   description: "Unexpected response!",
      //   duration: 3,
      // });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const jenisPengikatanCode = createSlice({
  name: "jenisPengikatanCode",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder
      //get jenisPengikatan code list
      .addCase(getJenisPengikatanCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getJenisPengikatanCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.jenisPengikatanCodeList = action.payload;
      })
      .addCase(getJenisPengikatanCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showNotification, hideNotification, showLoading } =
  jenisPengikatanCode.actions;

export default jenisPengikatanCode.reducer;
